
import PreLoginLayout from 'layout/auth/PreLoginLayout';
import FormHeader from './components/FormHeader';
import LoginForm from './components/LoginForm';

const Login: React.FC = () => {
    const header = (
            <FormHeader/>
    );

    const body = (
        <LoginForm/>
    );
return (
        <PreLoginLayout header={header} body={body} />
    );
};

export default Login;
